import { jsx as s } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useCallback as u, useMemo as O } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { useFetch as k } from "../../../../../hooks/useFetch.js";
import { BASE_CLASS as q, ITEM_CLASS as y } from "./constants.js";
import { memo as L } from "../../../../../external/preact/compat/dist/compat.module.js";
import { useResponsiveViewport as N, mediaQueries as _ } from "../../../../../hooks/useResponsiveViewport.js";
/* empty css                       */
import { TotalsCard as a } from "./TotalsCard.js";
import { Fragment as v } from "../../../../../external/preact/dist/preact.module.js";
import { useConfigContext as B } from "../../../../../core/ConfigContext/context.js";
import { EMPTY_OBJECT as j } from "../../../../../utils/value/constants.js";
const Z = L(
  ({
    availableCurrencies: i,
    isAvailableCurrenciesFetching: F,
    balanceAccountId: t,
    createdSince: f,
    createdUntil: d,
    categories: l,
    statuses: c,
    maxAmount: h,
    minAmount: C,
    currencies: T,
    fullWidth: n
  }) => {
    const { getTransactionTotals: r } = B().endpoints, x = u(async () => r == null ? void 0 : r(j, {
      query: {
        createdSince: f,
        createdUntil: d,
        categories: l,
        statuses: c,
        maxAmount: h,
        minAmount: C,
        currencies: T,
        balanceAccountId: t
      }
    }), [t, l, f, d, T, r, h, C, c]), { data: o, isFetching: S } = k({
      fetchOptions: O(() => ({ enabled: !!t && !!r }), [t, r]),
      queryFn: x
    }), m = !t || S || F, p = u(() => {
      if (!i || !o)
        return o == null ? void 0 : o.data;
      const g = i.map((e) => o.data.find((M) => M.currency === e) || { currency: e, incomings: 0, expenses: 0 });
      return g.concat(o.data.filter((e) => !g.includes(e)));
    }, [i, o])() ?? [], E = N(_.only.xs);
    return /* @__PURE__ */ s("div", { className: q, children: E ? /* @__PURE__ */ s(v, { children: [
      /* @__PURE__ */ s("div", { className: y, children: /* @__PURE__ */ s(a, { totals: p, isLoading: m, hiddenField: "expenses", fullWidth: n }) }),
      /* @__PURE__ */ s("div", { className: y, children: /* @__PURE__ */ s(a, { totals: p, isLoading: m, hiddenField: "incomings", fullWidth: n }) })
    ] }) : /* @__PURE__ */ s(a, { totals: p, isLoading: m, fullWidth: n }) });
  }
);
export {
  Z as default
};
